<a
    class="list-card-name"
    [ngClass]="{ 'list-card-name-no-svg': !item.svgId, 'list-card-name-lads': isV2Design }"
    linkHref
    [link]="link"
    [textContent]="title || item.name"
    [vnSpeculativeLink]="link"
    data-crlat="couponName"></a>
@if (date) {
    <div class="list-card-date" [textContent]="date" data-crlat="event.date"></div>
}
<ng-content></ng-content>
